import { render, staticRenderFns } from "./DatasetMetadataSchemaAddForm.vue?vue&type=template&id=4c3adae2&scoped=true"
import script from "./DatasetMetadataSchemaAddForm.vue?vue&type=script&lang=js"
export * from "./DatasetMetadataSchemaAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3adae2",
  null
  
)

export default component.exports